export default function mapper(instance, methodName) {
  let value = instance[methodName];
  Object.keys(value).forEach(key => {
    const rawValue = value[key];
    value[key] = function() {
      return rawValue.apply(instance, arguments);
    };
  });
  return { value };
}



// WEBPACK FOOTER //
// ./src/components/vm-component/mapper/index.js